export default {
  container: [
    'h-full',
    'flex',
    'flex-col',
    'bg-white',
  ].join(' '),
  submenu: [
    'absolute',
    'w-60',
    'left-0',
    'top-0',
    'opacity-0',
    'group-hover:left-full',
    'group-hover:opacity-100',
    'transition-[left,opacity,color]',
    'ease-in',
    'group-hover:ease-out',
    'delay-200',
    'duration-200',
    'border',
    'border-gray-15',
    'border-r-0',
    'rounded-r-lg',
    'py-1',
    'box-border',
    'pointer-events-none',
    'group-hover:pointer-events-auto',
    'shadow-[4px_0_8px_-3px_rgba(0,0,0,0.15)]',
  ].join(' '),
  submenuItem: ['cursor-pointer my-1 mx-2'].join(' '),
  item: ['bg-white', 'group', 'flex-grow-0'].join(' '),
  separator: ['h-px', 'bg-gray-15', 'my-2', 'border-y-10', 'border-white'].join(
    ' '
  ),
  itemButton: [
    'px-4',
    'py-2',
    'rounded-lg',
    'box-border',
    'cursor-pointer',
    'hover:bg-gray-10',
    'hover:text-gray-90',
    'transition-[colors,width]',
    'duration-300',
    'flex',
    'items-center',
    'justify-center',
    'text-sm',
  ].join(' '),
  parentItem: ['z-10', 'relative', 'pb-1', 'px-2', 'bg-white'].join(' '),
  selectedItem: [
    'bg-gray-10',
    'border-l-4',
    'border-med-blue-30',
    'group-hover:border-med-blue-40',
    'text-gray-90',
    'rounded-l-sm',
    'pl-3',
  ].join(' '),
};
